export default __webpack_public_path__ + "static/Денежный поток 303+404_8-e809fb28407ad1c511158b18e2329ecd.jpg";